<div class="border-radius-bottom m-2 main-black p-4 white-box">
	<h3>{{'demo_site_pairs.title' | translate}}</h3>
	<p class="text-muted"><small>{{'demo_site_pairs.page_hint' | translate}}</small></p>
	<div>
		<button type="button" class="btn btn-primary mt-2 mb-3" (click)="showAddPairModal()">{{'demo_site_pairs.add_pair' | translate}}</button>
		<sct-custom-table
			*ngIf="pairsTableData.length; else noData"
			[config]="tableConfig"
			[columnsConfig]="columnConfig"
			[data]="pairsTableData">
		</sct-custom-table>
	</div>
</div>

<ng-template #noData>
	<div class="alert alert-info">{{'demo_site_pairs.no_pairs' | translate}}</div>
</ng-template>

<app-modal #addPairModal [hasConfirmButton]="false" [hasCloseButton]="false" title="{{'demo_site_pairs.add_pair' | translate}}" size="lg">
	<div class="col-sm-12 card-body">
		<div class="row" *ngIf="saveError">
			<div class="col-md-12">
				<div class="alert alert-danger">{{saveError}}</div>
			</div>
		</div>

		<div class="row mt-2 align-items-center">
			<div class="col-md-4">
				<strong>{{'demo_site_pairs.source_site' | translate}}</strong>
			</div>
			<div class="col-md-8">
				<ng-select
					id="source_site"
					name="source_site"
					[items]="sitesList"
					bindLabel="name"
					bindValue="id"
					placeholder="{{'demo_site_pairs.source_site' | translate}}"
					[(ngModel)]="newPair.sourceSiteId"
					(ngModelChange)="saveError = ''"
					[clearable]="true"
					[searchable]="true">
				</ng-select>
			</div>
		</div>

		<div class="row mt-3 align-items-center">
			<div class="col-md-4">
				<strong>{{'demo_site_pairs.demo_site' | translate}}</strong>
			</div>
			<div class="col-md-8">
				<ng-select
					id="demo_site"
					name="demo_site"
					[items]="sitesList"
					bindLabel="name"
					bindValue="id"
					placeholder="{{'demo_site_pairs.demo_site' | translate}}"
					[(ngModel)]="newPair.targetSiteId"
					(ngModelChange)="saveError = ''"
					[clearable]="true"
					[searchable]="true">
				</ng-select>
			</div>
		</div>

		<div class="row mt-3">
			<div class="col-md-12">
				<div class="alert alert-warning mb-0"><small>{{'demo_site_pairs.add_pair_hint' | translate}}</small></div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-primary" (click)="savePair()">{{'g.confirm' | translate}}</button>
		<button type="button" class="btn btn-light" (click)="hideAddPairModal()">{{'g.close' | translate}}</button>
	</div>
</app-modal>

<app-modal #deletePairModal title="{{'g.confirm_action' | translate}}" closeBtnText="{{'g.no' | translate}}" confirmBtnText="{{'g.yes' | translate}}">
	<p>{{'demo_site_pairs.confirm_delete_pair' | translate:{"source": selectedSourceName, "target": selectedTargetName} }}</p>
</app-modal>

<app-modal #refreshPairModal title="{{'g.confirm_action' | translate}}" closeBtnText="{{'g.no' | translate}}" confirmBtnText="{{'g.yes' | translate}}">
	<p>{{'demo_site_pairs.confirm_refresh' | translate:{"source": selectedSourceName, "target": selectedTargetName} }}</p>
	<div class="alert alert-danger mb-0"><small>{{'demo_site_pairs.confirm_refresh_warning' | translate}}</small></div>
</app-modal>

<app-modal #removePairModal title="{{'g.confirm_action' | translate}}" closeBtnText="{{'g.no' | translate}}" confirmBtnText="{{'g.yes' | translate}}">
	<p>{{'demo_site_pairs.confirm_remove_pair' | translate:{"source": selectedSourceName, "target": selectedTargetName} }}</p>
	<div class="alert alert-danger mb-0"><small>{{'demo_site_pairs.confirm_remove_pair_warning' | translate}}</small></div>
</app-modal>
